// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to info@fahrschule-star.ch.

// ----------------------------------------------------------------------

const en = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  welcomeHome: "Learn Driving and Traffic Rules",
  welcomeMinimal:
    "We collected most popular elements. Menu, sliders, buttons, inputs etc. are all here. Just dive in!",
  drivingLessonsHome: "Learn Driving and Traffic Rules",
  drivingLessonsHomeDesc:
    "In our driving school you can pay for your driving license in installments. If you want to learn to drive an automatic or manual transmission, you don't have to save a lot. We give you professional driving lessons and allow you to pay for your driving lessons in installments.",
  welcomeTextHero: "We Learn to Drive Easy",
  RegistrationBtn: "Registration",
  MoreBtn: "More",
  reviewStar: "reviews",
  title1Course: "First Aid",
  parraph1Course: `First aid course for only 69 CHF.
  We offer the emergency helper course (NHK) in the regions of Aarau, Baden and Zurich at a reasonable price. For only CHF 69 (incl. driver's license) you can learn the first aid that is mandatory for the driver's license.`,
  firstAidHome: "First Aid",
  firstAidHomeDesc: `First aid course for only 69 CHF.
  We offer the emergency helper course (NHK) in the regions of Aarau, Baden and Zurich at a reasonable price. For only CHF 69 (incl. driver's license) you can learn the first aid that is mandatory for the driver's license.`,
  title2Course: "VKU",
  parraph2Course: `The obligatory traffic instruction (VKU) consists of four double lessons and can be completed parallel to the practical driving lessons. However, it is advisable to visit the VKU as early as possible so that important information can be applied in practical driving lessons.

  The VKU can only be visited with a valid learner's license. This must be brought to the VKU.`,
  vkuHome: "VKU",
  vkuHomeDesc: `The obligatory traffic instruction (VKU) consists of four double lessons and can be completed parallel to the practical driving lessons. However, it is advisable to visit the VKU as early as possible so that important information can be applied in practical driving lessons.

  The VKU can only be visited with a valid learner's license. This must be brought to the VKU.`,
  motoHome: `MOTO`,
  motoHomeDesc: `We have structured our basic motorcycle course in such a way that you hardly need any driving lessons (provided you achieve the course objectives and practice). A driving lesson for the test gives you an impression of how the test will go and helps you determine where you stand.`,
  navHome: "Home",
  navDrive: "Drive",
  navFirstAid: "First aid",
  navVku: "VKU",
  navMoto: "Moto",
  navPrice: "Price",
  navPages: "Pages",
  navVouchers: "Vouchers",
  navContact: "Contact us",
  navTeam: "Team",

  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
};

export default en;
